import { Observable, Unsubscribable } from "rxjs";

export abstract class IStore<T> {
  abstract getState(): T;
  abstract select<TSelected>(
    selector: (state: T) => TSelected,
  ): Observable<TSelected>;
  abstract subscribe(observer: (state: T) => unknown): Unsubscribable;
}
